<template>
    <table-template ref="business-coupons-table-template" actionUrl="/dbtCard/findBusinessConsumerCoupons.action" :queryParams="queryParams">

        <template slot="search">
            <el-select v-model="queryParams.status" @change="$refs['business-coupons-table-template'].search()" clearable  placeholder="请选择状态">
                <el-option label="待审核" :value="1"></el-option>
                <el-option label="审核通过" :value="2"></el-option>
                <el-option label="审核不通过" :value="3"></el-option>
            </el-select>
            <el-select v-model="queryParams.type" @change="$refs['business-coupons-table-template'].search()" clearable  placeholder="卡券类型">
                <el-option label="优惠券" :value="1"></el-option>
                <el-option label="福利券" :value="2"></el-option>

            </el-select>
            <el-date-picker
                    clearable
                    style="margin-left: 10px;"
                    v-model="createTimeSearch"
                    @change="onCreateTimeChanged"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="申请时间开始"
                    end-placeholder="申请时间截止">
            </el-date-picker>

            <el-input style="margin-left: 10px;width: 200px;" v-model="queryParams.keyword" placeholder="商家名称/姓名/手机号/券名称"></el-input>
            <el-button style="margin-left: 10px;" type="primary" @click="$refs['business-coupons-table-template'].search()">搜索</el-button>
        </template>
        <template slot="item">
            <el-table-column
                    prop="businessName"
                    label="商家名称">
            </el-table-column>
            <el-table-column
                    prop="contacts"
                    label="负责人姓名">
            </el-table-column>
            <el-table-column
                    prop="phone"
                    label="联系方式">
            </el-table-column>
            <el-table-column
                    prop="couponName"
                    label="申请接劵名称">
            </el-table-column>
            <el-table-column
                    prop="purpose"
                    label="平台券内容">
            </el-table-column>

            <el-table-column
                    label="卡券类型"   width="80">
                <template scope="scope">
                    <span v-if="scope.row.type == 1">优惠券</span>
                    <span v-else>福利券</span>

                </template>
            </el-table-column>

            <el-table-column
                    label="状态">
                <template scope="scope">
                    <span v-bind:style="{color:getStatusColor(scope.row.auditStatus)}">{{scope.row.auditStatus|statusFilter}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="申请时间">
                <template scope="scope">
                    {{scope.row.createTime | dateTimeFormat}}
                </template>
            </el-table-column>
            <el-table-column
                    label="操作">
                <template scope="scope">
                    <el-button type="primary" size="small" v-confirm confirm-text="确定通过申请?" requestUrl="dbtCard/changeBusinessConsumerCouponsStatus.action" :confirm-data="{id:scope.row.id,status:2}" @onConfirm="$refs['business-coupons-table-template'].loadList()">通过</el-button>
                    <el-button type="danger" size="small" v-confirm confirm-text="确定不通过申请?" requestUrl="dbtCard/changeBusinessConsumerCouponsStatus.action" :confirm-data="{id:scope.row.id,status:3}" @onConfirm="$refs['business-coupons-table-template'].loadList()">不通过</el-button>
                </template>
            </el-table-column>
        </template>
    </table-template>
</template>
<script>
import TableTemplate from '@/components/TableTemplate'
export default {
  name: 'consumer-coupons-apply',
  data () {
    return {
      createTimeSearch: null,
      queryParams: {}
    }
  },
  components: { TableTemplate },
  filters: {
    statusFilter (value) {
      let filter_value = '暂无'
      switch (value) {
        case 1:// 审核中
          filter_value = '待审核'
          break
        case 2:// 审核通过
          filter_value = '审核通过'
          break
        case 3:// 审核失败
          filter_value = '审核不通过'
          break
      }
      return filter_value
    }
  },
  methods: {
    onCreateTimeChanged (datetime) {
      if (!datetime || datetime[0] == null) {
        this.queryParams.createTimeSearchStart = null
        this.queryParams.createTimeSearchEnd = null
        this.$refs['business-coupons-table-template'].search()
        return
      }
      this.queryParams.createTimeSearchStart = datetime[0].getTime()
      this.queryParams.createTimeSearchEnd = datetime[1].getTime()
      this.$refs['business-coupons-table-template'].search()
    },
    getStatusColor (status) {
      let color = ''
      switch (status) {
        case 1:// 1-待审核
          color = '#E6A23C'
          break
        case 2:// 审核通过
          color = '#00CC00'
          break
        default:// 2-审核失败;
          color = '#FF0000'
      }
      return color
    }
  }
}
</script>
